import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  selectedRevenue: {
    right: '10px', 
    top: '80px', 
    position: 'absolute'
  }
}));